module.exports = __webpack_public_path__ + "static/media/loader2.5849f475.gif";